// extracted by css-extract-rspack-plugin
export default {"animate":"_4998f3f7","shimmerLoadingBackground":"_9cc22421"};